import React from 'react'

import { HeaderSection } from './styles/headerStyles'

const Header = () => {
  return (
    <HeaderSection>
      <h1>Moody todos</h1>
    </HeaderSection>
  )
}

export default Header
